import { signal } from '@preact/signals'
import { Product } from 'apps/commerce/types.ts'

import c from 'site/sdk/c.ts'
import Icon from 'site/components/ui/Icon.tsx'
import ProductCard from 'site/components/product/ProductCard.tsx'
import { useSimilarsFormated } from 'site/sdk/useSimilars.ts'
import type { SlimProduct } from 'site/types.ts'

interface ModalProduct extends SlimProduct {
    pixDiscount?: number
}

const selectedProduct = signal<ModalProduct | null>(null)
const selectedProductSimilars = signal<Product[]>([])

interface ModalSimilarsTriggerProps {
    product: ModalProduct
}

const useModalSimilars = () => {
    return {
        selectedProduct,
        selectedProductSimilars,
    }
}

export function ModalSimilars() {
    const { selectedProduct, selectedProductSimilars } = useModalSimilars()

    const currentProduct = selectedProduct.value
    const isOpen = selectedProduct.value !== null
    const pixDiscount = currentProduct?.pixDiscount

    const handleCloseModal = () => {
        selectedProduct.value = null
        document.documentElement.classList.remove('overflow-hidden')
    }

    const handleOpenModal = () => {
        document.documentElement.classList.add('overflow-hidden')
    }

    if (isOpen) {
        handleOpenModal()
    }

    const selectedProductsSimilarsFiltered = selectedProductSimilars.value.filter((
        product: Product,
    ) => product.isVariantOf?.hasVariant.some((variant) => variant.offers?.offers.some((offer) => offer.availability === 'https://schema.org/InStock'),
    ))

    return (
        <>
            {isOpen && (
                <div class='fixed inset-0 bg-black opacity-50 z-[998]' onClick={handleCloseModal}>
                </div>
            )}

            <div
                class={c(
                    'fixed right-0 bottom-0 z-[999] w-[95%] md:w-4/5 h-full transition-transform duration-300 bg-white max-w-[1052px] px-[14px] lg:px-6 py-10 lg:py-7',
                    isOpen && 'translate-x-0',
                    !isOpen && 'translate-x-full',
                )}
            >
                {currentProduct && (
                    <div class='flex flex-col h-full max-h-none md:max-h-[874px]'>
                        <h3 class='text-neutral-0 text-base lg:text-2xl font-bold flex items-center justify-between w-full mb-2 h-[36px]'>
                            <span>
                                Resultado do Filtro
                            </span>

                            <button
                                class='w-6 h-6 flex justify-center items-center top-10 lg:top-1 right-[10px] lg:right-[14px]'
                                onClick={handleCloseModal}
                            >
                                <Icon width={24} height={24} fill={'#171717'} id='X' />
                            </button>
                        </h3>

                        <div class='flex flex-col lg:flex-row lg:justify-between w-full h-full'>
                            <div class='flex flex-col w-full lg:min-w-[321px] max-w-[379px] lg:max-w-[321px] mb-[14px] lg:mr-7'>
                                <div class='bg-[#F2F2F2] p-2 lg:px-[14px] lg:pt-3 lg:pb-5 w-full'>
                                    <ProductCard
                                        modalSimilarsRenderHorizontally={self.innerWidth < 1024}
                                        seals={[]}
                                        product={currentProduct}
                                        timers={[]}
                                        pixDiscount={pixDiscount}
                                    />
                                </div>
                            </div>

                            <div
                                class={'flex flex-col w-full h-full justify-between overflow-y-auto'}
                            >
                                <div
                                    data-similars={true}
                                    data-scrolling={self.innerWidth < 1024
                                        ? selectedProductsSimilarsFiltered.length > 2
                                        : selectedProductsSimilarsFiltered.length > 7}
                                    class='w-full max-h-[568px] lg:max-h-[874px] grid grid-cols-2 lg:grid-cols-[repeat(auto-fill,minmax(195px,1fr))] gap-2 gap-y-6 lg:gap-3 lg:gap-y-5 lg:mt-0 mb-2 lg:mb-3 similars-gallery group/similars data-[scrolling=true]:pr-1 lg:data-[scrolling=true]:pr-2'
                                >
                                    {selectedProductsSimilarsFiltered?.map((product: Product) => (
                                        <div class='w-full max-w-[178px] lg:max-w-[195px]'>
                                            <ProductCard
                                                seals={[]}
                                                product={product}
                                                timers={[]}
                                                pixDiscount={pixDiscount}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <span class={'text-sm text-neutral-0 ml-auto block'}>
                                    <strong>{selectedProductsSimilarsFiltered.length}</strong>
                                    {'  produtos encontrados'}
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export const ModalSimilarsTrigger = ({ product }: ModalSimilarsTriggerProps) => {
    const { selectedProduct } = useModalSimilars()

    const handleClick = async (e: MouseEvent) => {
        e.preventDefault()

        const similars = await useSimilarsFormated(product, true)

        if (!similars.length) return

        selectedProductSimilars.value = similars ?? null
        selectedProduct.value = product
    }

    return (
        <button
            class='bg-[#003A70] w-full h-[30px] lg:h-[34px] flex items-center justify-center text-white font-bold'
            onClick={handleClick}
        >
            <Icon id='TableSearch' width={20} height={20} class='text-white' />
            Ver mais cores
        </button>
    )
}
